// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== POPUP PROMO SPECIAL - STILI COMPLETI ===== */

/* Titolo principale del popup */
.popup-promo-special .titolo_popup_generico {
    font-size: 32px;
    font-weight: bold;
    color: #ff1b8d;
    text-align: center;
    margin: 20px 0 10px 0;
    line-height: 1.2;
}

/* Descrizione sotto il titolo */
.popup-promo-special .modal-body h4 {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    margin: 15px 0;
}

.popup-promo-special .modal-body h4 strong {
    font-weight: 600;
    color: #ff1b8d;
}

/* Container principale offerta promo */
.promo-offer-container {
    margin: 30px auto;
    max-width: 500px;
    text-align: center;
    animation: slideInDown 0.4s ease-out;
}

/* Badge superiore rosa con testo bianco */
.promo-offer-badge {
    background: linear-gradient(135deg, #ff1b8d 0%, #ff006e 100%);
    color: white;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.3;
    padding: 12px 20px;
    border-radius: 20px 20px 0 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 8px rgba(255, 27, 141, 0.3);
}

/* Tabella a 2 colonne */
.promo-offer-table {
    display: flex;
    border: 3px solid #ff1b8d;
    border-radius: 0 0 20px 20px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(255, 27, 141, 0.2);
}

/* Celle della tabella */
.promo-offer-cell {
    flex: 1 1;
    padding: 8px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* Colonna sinistra (crediti) - sfondo bianco */
.promo-credits {
    background: white;
    border-right: 2px solid #ff1b8d;
}

/* Quantità crediti con icona */
.credits-amount {
    font-size:2em;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center;


}

.coins-icon {
    font-size: 36px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* Label "Crediti" */
.credits-label {
    font-size: 18px;
    color: #666;
    font-weight: 500;
    text-transform: capitalize;
}

/* Colonna destra (prezzo) - sfondo rosa chiaro */
.promo-price {
    background: linear-gradient(135deg, #ffe6f3 0%, #ffd6ed 100%);
}

/* Prezzo vecchio barrato */
.old-price {
    font-size: 24px;
    color: #999;
    text-decoration: line-through;
    margin-bottom: 5px;
    font-weight: 500;
}

/* Prezzo nuovo in evidenza */
.new-price {
    font-size: 2em;
    font-weight: bold;
    color: #ff1b8d;
    text-shadow: 0 2px 4px rgba(255, 27, 141, 0.1);
}

/* Testo CTA sotto la tabella */
.promo-offer-cta {
    margin-top: 20px;
    font-size: 15px;
    line-height: 1.5;
    color: #333;
    padding: 0 20px;
}

.promo-offer-cta strong {
    color: #ff1b8d;
    font-weight: 600;
}

/* Pulsante footer principale */
.popup-promo-special .modal-footer .btn {
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    border: none;
    color: white;
    font-size: 18px;
    font-weight: bold;
    padding: 15px 30px;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
    transition: all 0.3s ease;
    width: 100%;
}

.popup-promo-special .modal-footer .btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.popup-promo-special .modal-footer .btn:active {
    transform: translateY(0);
}

/* Close button (X) styling */
.popup-promo-special .modal-header .btn-close {
    font-size: 24px;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.popup-promo-special .modal-header .btn-close:hover {
    opacity: 1;
}

/* Responsive per mobile */
@media (max-width: 576px) {
    .popup-promo-special .titolo_popup_generico {
        font-size: 26px;
        margin: 15px 0 10px 0;
    }

    .popup-promo-special .modal-body h4 {
        font-size: 16px;
    }

    .promo-offer-badge {
        font-size: 14px;
        padding: 10px 15px;
    }

    .credits-amount {
        font-size: 36px;
    }

    .coins-icon {
        font-size: 28px;
    }

    .credits-label {
        font-size: 16px;
    }

    .old-price {
        font-size: 20px;
    }

    .new-price {
        font-size: 36px;
    }

    .promo-offer-cta {
        font-size: 14px;
        padding: 0 15px;
    }

    .popup-promo-special .modal-footer .btn {
        font-size: 16px;
        padding: 12px 25px;
    }
}

/* Animazione entrata */
@keyframes slideInDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Modal fullscreen override per promo */
.popup-promo-special.modal-fullscreen {
    padding: 20px;
}

.popup-promo-special .modal-body {
    padding: 30px 20px;
}

.popup-promo-special .modal-footer {
    border-top: none;
    padding: 20px;
    justify-content: center;
}

/* Icona regalo */
.popup-promo-special .icona_popup_generico img {
    filter: drop-shadow(0 4px 8px rgba(255, 27, 141, 0.2));
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/popup/component/css/promo_offer.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,gCAAgC;AAChC;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,0CAA0C;AAC1C;IACI,6DAA6D;IAC7D,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA,wBAAwB;AACxB;IACI,SAAO;IACP,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;;;AAGvB;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,iDAAiD;AACjD;IACI,6DAA6D;AACjE;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,8CAA8C;AAClD;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA,0BAA0B;AAC1B;IACI;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,wCAAwC;AACxC;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,sDAAsD;IACtD,wCAAwC;AAC5C;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["/* ===== POPUP PROMO SPECIAL - STILI COMPLETI ===== */\n\n/* Titolo principale del popup */\n.popup-promo-special .titolo_popup_generico {\n    font-size: 32px;\n    font-weight: bold;\n    color: #ff1b8d;\n    text-align: center;\n    margin: 20px 0 10px 0;\n    line-height: 1.2;\n}\n\n/* Descrizione sotto il titolo */\n.popup-promo-special .modal-body h4 {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #333;\n    margin: 15px 0;\n}\n\n.popup-promo-special .modal-body h4 strong {\n    font-weight: 600;\n    color: #ff1b8d;\n}\n\n/* Container principale offerta promo */\n.promo-offer-container {\n    margin: 30px auto;\n    max-width: 500px;\n    text-align: center;\n    animation: slideInDown 0.4s ease-out;\n}\n\n/* Badge superiore rosa con testo bianco */\n.promo-offer-badge {\n    background: linear-gradient(135deg, #ff1b8d 0%, #ff006e 100%);\n    color: white;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 1.3;\n    padding: 12px 20px;\n    border-radius: 20px 20px 0 0;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    box-shadow: 0 2px 8px rgba(255, 27, 141, 0.3);\n}\n\n/* Tabella a 2 colonne */\n.promo-offer-table {\n    display: flex;\n    border: 3px solid #ff1b8d;\n    border-radius: 0 0 20px 20px;\n    overflow: hidden;\n    box-shadow: 0 4px 15px rgba(255, 27, 141, 0.2);\n}\n\n/* Celle della tabella */\n.promo-offer-cell {\n    flex: 1;\n    padding: 8px 15px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Colonna sinistra (crediti) - sfondo bianco */\n.promo-credits {\n    background: white;\n    border-right: 2px solid #ff1b8d;\n}\n\n/* Quantità crediti con icona */\n.credits-amount {\n    font-size:2em;\n    font-weight: bold;\n    color: #333;\n    display: flex;\n    align-items: center;\n\n\n}\n\n.coins-icon {\n    font-size: 36px;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n/* Label \"Crediti\" */\n.credits-label {\n    font-size: 18px;\n    color: #666;\n    font-weight: 500;\n    text-transform: capitalize;\n}\n\n/* Colonna destra (prezzo) - sfondo rosa chiaro */\n.promo-price {\n    background: linear-gradient(135deg, #ffe6f3 0%, #ffd6ed 100%);\n}\n\n/* Prezzo vecchio barrato */\n.old-price {\n    font-size: 24px;\n    color: #999;\n    text-decoration: line-through;\n    margin-bottom: 5px;\n    font-weight: 500;\n}\n\n/* Prezzo nuovo in evidenza */\n.new-price {\n    font-size: 2em;\n    font-weight: bold;\n    color: #ff1b8d;\n    text-shadow: 0 2px 4px rgba(255, 27, 141, 0.1);\n}\n\n/* Testo CTA sotto la tabella */\n.promo-offer-cta {\n    margin-top: 20px;\n    font-size: 15px;\n    line-height: 1.5;\n    color: #333;\n    padding: 0 20px;\n}\n\n.promo-offer-cta strong {\n    color: #ff1b8d;\n    font-weight: 600;\n}\n\n/* Pulsante footer principale */\n.popup-promo-special .modal-footer .btn {\n    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\n    border: none;\n    color: white;\n    font-size: 18px;\n    font-weight: bold;\n    padding: 15px 30px;\n    border-radius: 10px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);\n    transition: all 0.3s ease;\n    width: 100%;\n}\n\n.popup-promo-special .modal-footer .btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);\n}\n\n.popup-promo-special .modal-footer .btn:active {\n    transform: translateY(0);\n}\n\n/* Close button (X) styling */\n.popup-promo-special .modal-header .btn-close {\n    font-size: 24px;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n}\n\n.popup-promo-special .modal-header .btn-close:hover {\n    opacity: 1;\n}\n\n/* Responsive per mobile */\n@media (max-width: 576px) {\n    .popup-promo-special .titolo_popup_generico {\n        font-size: 26px;\n        margin: 15px 0 10px 0;\n    }\n\n    .popup-promo-special .modal-body h4 {\n        font-size: 16px;\n    }\n\n    .promo-offer-badge {\n        font-size: 14px;\n        padding: 10px 15px;\n    }\n\n    .credits-amount {\n        font-size: 36px;\n    }\n\n    .coins-icon {\n        font-size: 28px;\n    }\n\n    .credits-label {\n        font-size: 16px;\n    }\n\n    .old-price {\n        font-size: 20px;\n    }\n\n    .new-price {\n        font-size: 36px;\n    }\n\n    .promo-offer-cta {\n        font-size: 14px;\n        padding: 0 15px;\n    }\n\n    .popup-promo-special .modal-footer .btn {\n        font-size: 16px;\n        padding: 12px 25px;\n    }\n}\n\n/* Animazione entrata */\n@keyframes slideInDown {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Modal fullscreen override per promo */\n.popup-promo-special.modal-fullscreen {\n    padding: 20px;\n}\n\n.popup-promo-special .modal-body {\n    padding: 30px 20px;\n}\n\n.popup-promo-special .modal-footer {\n    border-top: none;\n    padding: 20px;\n    justify-content: center;\n}\n\n/* Icona regalo */\n.popup-promo-special .icona_popup_generico img {\n    filter: drop-shadow(0 4px 8px rgba(255, 27, 141, 0.2));\n    animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.05);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
